module.exports = __webpack_public_path__ + "img/customized.65e73ef.svg";